<template>
  <v-row no-gutters>
    <v-col cols="12" md="4" order="2" order-md="1" class="pa-2">
      <v-card flat class="rounded-lg pa-3 user-link-wrapper overflow-hidden">
        <v-slide-x-transition mode="out-in">
          <v-card flat width="100%" v-if="!isIntersecting && $vuetify.breakpoint.mdAndUp"
                  class="rounded-lg overflow-hidden clickable" @click="goToTop">
            <v-img src="/media/menu/1620282727329.webp" width="100%"/>
          </v-card>
        </v-slide-x-transition>

        <v-list>
          <v-list-item-group v-model="userLinkModel" color="primary">

            <v-list-item class="primary white--text rounded-lg mb-2" dark two-line link href="#/menu/profile">
              <v-list-item-icon class="white rounded-pill pa-3 my-3">
                <v-icon color="primary">mdi-account-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>مشخصات</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon>mdi-chevron-left</v-icon>
              </v-list-item-action>
            </v-list-item>

            <v-list-item v-for="(x, i) in userLinks" :key="i" :href="x.link" link class="rounded-lg overflow-hidden">
              <v-list-item-icon class="me-3">
                <v-icon :color="x.color ? x.color : 'primary'">mdi-{{ x.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="x.title"/>
              </v-list-item-content>
            </v-list-item>

          </v-list-item-group>
        </v-list>
      </v-card>
    </v-col>

    <v-col cols="12" md="8" order="1" order-md="2" class="pa-2">
      <v-card flat class="rounded-lg overflow-hidden">
        <v-img src="/media/menu/1620282727329.webp" :aspect-ratio="16/9" width="100%" class="mb-16"
               v-intersect="onIntersect">
          <template v-slot:default>
            <div class="profile-img-wrapper">
              <div class="img-holder">
                <v-badge icon="mdi-pencil">
                  <img src="/media/menu/default.webp" alt="">
                </v-badge>
              </div>
            </div>
          </template>
        </v-img>

        <div>
          <v-card-title>وحید اثنی عشری</v-card-title>
          <v-card-subtitle class="font-size-h1">--</v-card-subtitle>
        </div>

        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" sm="4" lg="3" v-for="(x, i) in profileLinks" :key="i" class="pa-2">
              <v-card outlined class="overflow-hidden grey lighten-3" :href="x.link">
                <v-card-title class="justify-center text-center">
                  {{ x.text }}
                  <span class="font-size-sm ms-1">(2)</span>
                </v-card-title>
                <v-card-text class="text-center">
                  <v-icon x-large :color="colors[i]" class="rounded-pill grey lighten-2 pa-3">mdi-{{ x.icon }}</v-icon>
                </v-card-text>
                <v-divider class="ma-0 profile-details-hr" :class="colors[i]"/>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-divider/>
      <router-view/>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "profile",

  data: () => ({
    userLinks: [
      {title: 'تنظیمات', icon: 'cog-outline', link: '#/menu/profile/settings'},
      {title: 'تماس با پشتیبانی', icon: 'phone-outline', link: ''},
      {title: 'خروج از حساب', icon: 'logout', link: '', color: 'third'},
    ],
    profileLinks: [
      {text: 'سفارشات', link: '#/menu/profile/orders', icon: 'store-clock'},
      {text: 'آدرس ها', link: '#/menu/profile/addresses', icon: 'map-marker-path'},
    ],
    isIntersecting: true,
    userLinkModel: 0,
    colors: ['blue lighten-2', 'green', 'third', 'orange']
  }),

  methods: {
    onIntersect(entries, observer) {
      // More information about these options
      // is located here: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
      this.isIntersecting = entries[0].isIntersecting
    },
    goToTop() {
      window.scrollTo({behavior: 'smooth', top: 0, left: 0})
    }
  }
}
</script>

<style scoped lang="scss">
.user-link-wrapper {
  position: sticky;
  top: 12px;
}

.v-image {
  overflow: visible;
}

.profile-img-wrapper {
  width: 25%;
  aspect-ratio: 1;
  position: relative;

  .img-holder {
    border-radius: 50%;
    position: absolute;
    top: 35%;
    right: 15%;
    width: 100%;
    height: 100%;
    background: white;
    border: solid 2px white;
    overflow: hidden;
    box-shadow: 0 2px 5px 2px rgba(0, 0, 0, .1);

    img {
      width: 100%;
      max-width: 100%;
      object-fit: contain;
    }
  }
}

.profile-details-hr {
  border-width: thick 0 0;
}

.details-wrapper {
  label {
    margin-right: 4px;
  }
}
</style>